import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Gavel } from "lucide-react";

export default function SignIn() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get("next") || "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav(next);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Sign in failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[70vh] grid place-items-center px-4 py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 mb-8">
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-slate-900 text-amber-400"><Gavel className="h-5 w-5" /></span>
          <span className="font-extrabold text-xl">Auction<span className="text-amber-500">Bulls</span></span>
        </Link>
        <h1 className="text-3xl font-extrabold">Welcome back</h1>
        <p className="text-slate-500 mt-1">Sign in to bid, sell, and track your auctions.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label htmlFor="e">Email</Label>
            <Input data-testid="signin-email" id="e" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <Label htmlFor="p">Password</Label>
            <Input data-testid="signin-password" id="p" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <Button data-testid="signin-submit" type="submit" disabled={busy} className="w-full bg-slate-900 hover:bg-slate-800 text-white h-11">{busy ? "Signing in..." : "Sign In"}</Button>
        </form>
        <div className="mt-6 text-sm text-slate-500">
          No account? <Link className="font-semibold text-slate-900 dark:text-white" to="/signup">Create one — free</Link>
        </div>
      </div>
    </div>
  );
}
